import React from 'react';
import { Redirect } from 'react-router';
import './bookviewquran.styles.css';
    var bookUrl = "";
    function setUrlValue(){
      bookUrl = 'https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/quran%2Fquran.pdf?alt=media&token=bcc4d126-f95b-41f5-bdce-78b2f68f7799';
      // bookUrl = process.env.PUBLIC_URL+'/assets/quran.pdf';
    }
    function openNewPage(){
      window.open(bookUrl, '_blank', 'location=yes,innerHeight=500,innerWidth500,scrollbars=yes,status=yes');
    }
    const BookViewQuran = props => {       
      setUrlValue();
      return (
            <div className='container'>
              <h1>القرآن الكريم</h1>              
              {/* <ViewWebPage placelink='https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/quran%2Fquran.pdf?alt=media&token=bcc4d126-f95b-41f5-bdce-78b2f68f7799' /> */}
              {/* <PDFViewerComponent bookToViewLink='https://firebasestorage.googleapis.com/v0/b/anood-tafseer.appspot.com/o/quran%2Fquran.pdf?alt=media&token=bcc4d126-f95b-41f5-bdce-78b2f68f7799' /> */}
              <input className='timeTableButton' id='timeTableButton' type='button' value='download file' onClick={openNewPage}/>
              <br/><br/>
              <iframe src={bookUrl} width="100%" height="500px">
              </iframe>
            </div>
        );
    };
    export default BookViewQuran
    
        
